// components/CTASection.js
import React from "react";

import { FaCheckCircle } from "react-icons/fa"; // or use your custom icons

function CTASection() {
  return (
    <section className="py-16" style={{ backgroundColor: "rgba(244, 249, 252, 1)" }}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-12">
          {/* Image Section */}
          <div className="w-full md:w-1/2 text-center md:text-left">
            <img
              src="https://picsum.photos/500/400"
              alt="CTA"
              className="max-w-full h-auto rounded-lg shadow-xl"
            />
          </div>

          {/* Text Section */}
          <div className="w-full md:w-1/2">
            <p className="text-sm uppercase text-customcolor font-semibold mb-2">
              Our Mission & Vision
            </p>
            <h2 className="text-4xl font-bold text-gray-800 leading-tight mb-4">
              Keep Going With Your <span className="text-black">passion.</span>
            </h2>
            <p className="text-gray-600 text-base mb-6">
              Marketing experts in your niche with proven ROI results, backed by unbiased monitoring. Consistent unbiased monitoring to assure optimal results and accountability.
            </p>

            {/* Feature List */}
            <div className="space-y-6">
              <div className="flex items-start">
                <FaCheckCircle className="text-customcolor text-xl mt-1 mr-4" />
                <p className="text-gray-700">
                  Exponent is a modern business theme, that lets you build stunning high performance websites.
                </p>
              </div>
              <div className="flex items-start">
                <FaCheckCircle className="text-customcolor text-xl mt-1 mr-4" />
                <p className="text-gray-700">
                  Over 30 quality professionally designed pre-built website concepts to choose from.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


export default CTASection;
